import { FC } from 'react';
import { Box } from '@zoopla-eng/zds/box';
import { Button, ButtonLink } from '@zoopla-eng/zds/button';
import { Skeleton } from '@zoopla-eng/zds/skeleton';
import { ColouredCard } from '@zoopla-eng/zds/coloured-card';
import { styledTextStyle, titleStyle } from './Banner.styles.css';
import { bannerData } from './content';

import { fontGroups } from '@zoopla-eng/zds/themes';

export type Variants =
    | 'generic'
    | 'homeowner_not_claimed'
    | 'homeowner'
    | 'seller_not_claimed'
    | 'seller'
    | 'first_time_buyer'
    | 'renter'
    | 'no_your_situation';

export type BannerProps = {
    variant?: Variants;
    loading?: boolean;
    title?: string;
    content?: string;
    linkPath?: string;
    onButtonClick?: () => void;
};

export const Banner: FC<BannerProps> = ({
    variant,
    title,
    content,
    loading = false,
    linkPath,
    onButtonClick
}) => {
    if (loading || !variant) {
        return (
            <Box
                {...{
                    aspectRatio: '4 / 3',
                    maxHeight: '245px',
                    '@L100': {
                        maxHeight: '200px'
                    },
                    width: '100%'
                }}
            >
                <Skeleton.Root loadingText="Loading">
                    <Skeleton.Wave data-testid="onboarding-banner-skeleton" />
                </Skeleton.Root>
            </Box>
        );
    }

    const cardTitle = title || bannerData[variant].title;
    const cardContent = content || bannerData[variant].content;
    const buttonText = bannerData[variant].button;
    const buttonLink = linkPath || bannerData[variant].path;

    return (
        <ColouredCard backgroundColor="graphicBackgroundContrast">
            <Box bpL100={{ py: 'S400', px: 'M400' }} fw>
                <Box pb="S400" bpL100={{ pb: 'S200' }} fw>
                    <h2
                        className={`${titleStyle} ${fontGroups.plate}`}
                        data-testid="onboarding-banner-title"
                    >
                        {cardTitle}
                    </h2>
                </Box>
                <Box pb="S400" fw>
                    <p
                        className={`${styledTextStyle} ${fontGroups.ladle}`}
                        data-testid="onboarding-banner-content"
                    >
                        {cardContent}
                    </p>
                </Box>
                <Box bpM100={{ display: 'flex' }}>
                    <ButtonLink
                        data-testid="onboarding-banner-link"
                        category="secondary"
                        href={linkPath || buttonLink}
                        contrasted
                        onClick={onButtonClick}
                    >
                        {buttonText}
                    </ButtonLink>
                </Box>
            </Box>
        </ColouredCard>
    );
};
